__turbopack_context__.v({
  "icon": "SGkuoa_icon",
  "label": "SGkuoa_label",
  "links": "SGkuoa_links",
  "section": "SGkuoa_section",
  "tooltip": "SGkuoa_tooltip",
  "touchLabel": "SGkuoa_touchLabel",
});
